// ONE YORK AUTO DETAILING — shared brand constants
export const BRAND = {
  name: "ONE YORK",
  full: "ONE YORK AUTO DETAILING",
  tagline: "Premium Mobile Detailing in York Region",
  phone: "416 305 4898",
  phoneTel: "+14163054898",
  whatsapp: "14163054898",
  email: "contact@oneyorkdetailing.ca",
  instagram: "oneyorkdetailing",
  tiktok: "oneyorkdetailing",
  region: "York Region, Ontario",
  areas: [
    "Richmond Hill",
    "Vaughan",
    "Markham",
    "Thornhill",
    "Maple",
    "Aurora",
    "Newmarket",
    "King City",
  ],
};

export const waLink = (text) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
    text || "Hi ONE YORK — I'd like a quote for detailing my vehicle."
  )}`;

export const smsLink = (text) =>
  `sms:${BRAND.phoneTel}?&body=${encodeURIComponent(text || "Hi One York,")}`;

export const IMAGES = {
  hero: "/images/hero-dodge.jpg",
  ceramic: "/images/ceramic-coating.jpg",
  polishing: "https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1600",
  foamWash: "/images/full-detailing.jpg",
  interior:
    "https://images.unsplash.com/photo-1732357624591-f2137085659b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  wheels:
    "https://images.unsplash.com/photo-1606664914460-b667528c1acc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  exterior:
    "https://images.unsplash.com/photo-1621712151262-60bd142ba19f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aboutPortrait:
    "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  gallery: [
    {
      src: "/images/gallery/01-bentley-interior.jpg",
      alt: "Bentley Bentayga interior detailing — ONE YORK Auto Detailing, York Region",
    },
    {
      src: "/images/gallery/02-bentley-exterior.jpg",
      alt: "Bentley Bentayga ceramic coating & exterior detailing — York Region mobile detailing",
    },
    {
      src: "/images/gallery/03-mercedes-interior.jpg",
      alt: "Mercedes-Benz GLE 450 interior detailing — ONE YORK York Region",
    },
    {
      src: "/images/gallery/04-mercedes-exterior.jpg",
      alt: "Mercedes-Benz GLE 450 paint correction & ceramic coating — York Region",
    },
    {
      src: "/images/gallery/05-porsche-interior.jpg",
      alt: "Porsche Cayenne GTS interior detailing — ONE YORK Auto Detailing",
    },
    {
      src: "/images/gallery/06-porsche-exterior.jpg",
      alt: "Porsche Cayenne GTS ceramic coating exterior — York Region mobile detailing",
    },
    {
      src: "/images/gallery/07-lucid-interior.jpg",
      alt: "Lucid Gravity Touring interior detailing — premium mobile detailing York Region",
    },
    {
      src: "/images/gallery/08-lucid-exterior.jpg",
      alt: "Lucid Gravity Touring paint correction & ceramic coating — ONE YORK Detailing",
    },
    {
      src: "/images/gallery/09-acura-interior.jpg",
      alt: "Acura MDX interior detailing — ONE YORK Auto Detailing, Richmond Hill",
    },
    {
      src: "/images/gallery/10-acura-exterior.jpg",
      alt: "Acura MDX exterior detailing & ceramic coating — York Region",
    },
    {
      src: "/images/gallery/11-bmw-interior.jpg",
      alt: "BMW M5 Touring interior detailing — premium mobile detailing York Region",
    },
    {
      src: "/images/gallery/12-bmw-exterior.jpg",
      alt: "BMW M5 Touring ceramic coating & paint correction — ONE YORK Auto Detailing",
    },
    {
      src: "/images/gallery/13-glb250-interior.jpg",
      alt: "Mercedes-Benz GLB 250 interior detailing — Vaughan, Markham, Richmond Hill",
    },
    {
      src: "/images/gallery/14-glb250-exterior.jpg",
      alt: "Mercedes-Benz GLB 250 exterior detailing — York Region mobile service",
    },
    {
      src: "/images/gallery/15-sequoya-interior.jpg",
      alt: "Toyota Sequoia interior detailing — ONE YORK Auto Detailing, Newmarket",
    },
    {
      src: "/images/gallery/16-sequoya-exterior.jpg",
      alt: "Toyota Sequoia paint correction & ceramic coating — York Region detailing",
    },
  ],
};

export const SERVICES = [
  {
    key: "ceramic",
    title: "Ceramic Coating",
    eyebrow: "FEYNLAB Certified",
    idealFor:
      "drivers seeking premium, top-rated car care and luxury-grade protection designed to withstand Canada's harsh weather conditions and a standout presence.",
    image: IMAGES.ceramic,
    bullets: [
      "Long-lasting gloss and showroom shine",
      "Protects against UV rays and road salt",
      "Repels water, dirt, and contaminants",
      "Makes maintenance faster and easier",
      "Helps preserve paint and vehicle value",
      "Durable protection through all seasons",
    ],
    price: null,
    ctaLabel: "Request a quote",
    quoteMessage:
      "Hey One York, i would like a quote for CERAMIC COATING:\n\nVehicle's make & model __\nLocation __\nPaint condition __",
  },
  {
    key: "full",
    title: "Full Detailing",
    eyebrow: "Most Popular",
    idealFor:
      "everyday drivers and families in York Region who want a clean, safe, and well-maintained vehicle.",
    image: IMAGES.foamWash,
    bullets: [
      "Restores interior and exterior from daily wear",
      "Removes dirt, stains, spills, dust, and odors",
      "Helps protect surfaces and extend vehicle life",
      "Perfect for regular maintenance and family vehicles",
    ],
    price: { from: "$200", to: "$350" },
    ctaLabel: "Get a Fast Quote",
    quoteMessage:
      "Hey One York, i would like a quote for Detailing Service:\n\nVehicle's make & model __\nLocation __\nComments on condition __",
  },
];

export const ADDITIONAL_SERVICES = [
  {
    name: "Windshield Ceramic Coating",
    price: "$100",
    description:
      "Creates a hydrophobic barrier that repels rain, snow, and road grime, improving visibility and confidence during harsh Canadian weather.",
  },
  {
    name: "Leather Seat Treatment",
    price: "$90",
    description:
      "Protects against cracking, fading, and wear while preserving a luxurious feel, keeping your interior comfortable and premium longer.",
  },
  {
    name: "Paint Correction",
    price: null,
    quoteCta: true,
    description:
      "Removes swirls, scratches, and oxidation, restoring deep gloss and pride of ownership while maximizing your vehicle's appearance.",
    quoteMessage:
      "Hey One York, i would like a quote for Paint Correction:\n\nVehicle's make & model __\nLocation __\nPaint condition __",
  },
  {
    name: "Headlight Restoration",
    price: "$150",
    description:
      "Restores clarity and brightness for safer nighttime driving, helping protect your family during dark Canadian winters and storms.",
  },
  {
    name: "Engine Bay Detailing",
    price: "$120",
    description:
      "Removes dirt, salt, and grime buildup, improving presentation, easier maintenance, and preserving components from premature deterioration.",
  },
  {
    name: "Undercarriage Wash",
    price: "$40",
    popular: true,
    description:
      "Flushes away corrosive road salt and winter contaminants, helping prevent rust and protecting your vehicle's long-term value.",
  },
  {
    name: "Exterior Ceramic Sealant",
    price: "$100",
    description:
      "Adds durable protection against UV rays, rain, snow, salt, and contaminants while delivering lasting gloss and easier maintenance.",
  },
  {
    name: "Pet Hair Removal",
    priceFrom: "$50",
    priceTo: "$150",
    description:
      "Eliminates stubborn embedded pet hair, reducing allergens and restoring a fresh, comfortable interior your family enjoys.",
  },
];

export const TRUST = [
  "Mobile Service",
  "Fully Insured",
  "FEYNLAB Certified Installer",
  "York Region Coverage",
  "Premium Car Care",
];

export const WHY = [
  {
    title: "We Come To You",
    body: "Professional mobile detailing delivered to your home or workplace, anywhere across York Region.",
  },
  {
    title: "Premium Products",
    body: "We only use professional-grade chemicals, coatings and tools trusted by luxury automotive specialists.",
  },
  {
    title: "FEYNLAB Certified Installer",
    body: "Authorized installer of FEYNLAB ceramic coating systems with CARFAX registration and warranty.",
  },
  {
    title: "Luxury Vehicle Experience",
    body: "Trained on European exotics, performance SUVs and daily luxury — every vehicle treated with care.",
  },
  {
    title: "York Region Specialists",
    body: "Local detailers serving Richmond Hill, Vaughan, Markham, Thornhill and surrounding cities.",
  },
  {
    title: "Quality-First Approach",
    body: "No shortcuts. Every detail performed by hand with the patience luxury finishes demand.",
  },
];

export const REVIEWS = [
  {
    name: "Alisa",
    business: "Toronto Mommies",
    quote:
      "We got our car detailed on our driveways and the service was friendly, quick, quality was good and very friendly. Highly recommended car detailing from personal experience.",
  },
  {
    name: "Katia",
    business: "ACE Art Studio",
    quote:
      "Mobile detailing made it easy and stress free. Leo did an excellent job leaving the car fresh and well cared for. Solid work.",
  },
  {
    name: "Sofia",
    business: null,
    quote:
      "Absolutely outstanding experience with Leo & One York Detailing. The level of care, precision, and professionalism truly stands out…",
  },
  {
    name: "Dimitar",
    business: null,
    quote:
      "Leo did a great job cleaning both of my cars. He was very thorough, detail oriented, and clearly cares about the quality of his work…",
  },
  {
    name: "Simona",
    business: "Mayfair Law Group",
    quote:
      "I came across Leo and One York Auto Detailing on social media and he absolutely lived up to his posts and reviews. He took his time and ensured that my car looked better than when I picked it up from the dealership…",
  },
  {
    name: "Caterina",
    business: null,
    quote:
      "Having my car detailed by Leo at One York Detailing was an excellent experience for me. Leo was professional and thorough and took great care of my interior and exterior. My expectations are high…",
  },
  {
    name: "Pavel",
    business: null,
    quote:
      "I recently had my car detailed and the convenience of their mobile service is a total game-changer. They showed up right on time at my driveway with their own water and power supply…",
  },
  {
    name: "Giancarlo",
    business: "Green Paving",
    quote:
      "Excellent service! My truck had not been cleaned in over a year and I do heavy construction. It was a mess. One York did a fantastic job. My truck looks brand new…",
  },
];

export const FAQS = [
  {
    q: "Do you really come to my home or office?",
    a: "Yes. ONE YORK is a fully mobile detailing service. We arrive with our own water, power and equipment. Just point us to your vehicle.",
  },
  {
    q: "Which areas do you service?",
    a: "We service all of York Region including Richmond Hill, Vaughan, Markham, Thornhill, Maple, Aurora, Newmarket and King City.",
  },
  {
    q: "How long does a ceramic coating take?",
    a: "Most FEYNLAB ceramic coating installations require one to two full days depending on the package, paint correction stage and vehicle size.",
  },
  {
    q: "Is the ceramic coating warrantied?",
    a: "Yes. As a FEYNLAB Certified Installer we register your vehicle with CARFAX and provide a manufacturer-backed warranty.",
  },
  {
    q: "How do I book or get a quote?",
    a: "Use the quote form below or message us directly on WhatsApp. We typically respond within the same day.",
  },
  {
    q: "Do you service luxury and exotic vehicles?",
    a: "Absolutely. Our team is trained on European luxury, performance and exotic vehicles. Every car receives white-glove treatment.",
  },
];
